import React, { FC, memo } from 'react';
import { ViewWeb } from '../../utils/web-view';
import { localized } from 'shared/state/i18n/i18n';
import { WhiteText } from '../../Text/white-text';
import { SkioldTouchableOpacity } from '../../skiold-components/skiold-touchable-opacity';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { getTimeDateString } from 'shared/helpers/date-helpers';

interface SentDataPanelProps {
	items: any[];
	onClear: () => void;
	getDetailMessage: (row: any) => string | undefined;
}

export const SentDataPanel: FC<SentDataPanelProps> = memo(({ items, onClear, getDetailMessage }) => (
	<ViewWeb className="sent-data-panel">
		<ViewWeb className="sent-data-panel-header">
			<WhiteText>{localized('SentData')}</WhiteText>
			<SkioldTouchableOpacity onPress={onClear}>
				<WhiteText className="sent-data-clear">{localized('Clear')}</WhiteText>
			</SkioldTouchableOpacity>
		</ViewWeb>
		<ViewWeb className="sent-data-col-headers">
			<WhiteText className="sent-data-col-animal">{localized('animalNumber')}</WhiteText>
			<WhiteText className="sent-data-col-date">{localized('Date')}</WhiteText>
			<WhiteText className="sent-data-col-message">{localized('EsfResendMessage')}</WhiteText>
		</ViewWeb>
		{items.map(item => (
			<ViewWeb key={item.id} className="sent-data-row">
				<TextWeb className="sent-data-col-animal">{item.animalNumber}</TextWeb>
				<TextWeb className="sent-data-col-date">{getTimeDateString(item.createdOn)}</TextWeb>
				<TextWeb className="sent-data-col-message">{getDetailMessage(item)}</TextWeb>
			</ViewWeb>
		))}
	</ViewWeb>
));
